import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { KnowledgeBaseView } from '../components/views/knowledgebaseView'

function KnowledgeBase() {
    return (
        <div className="knowledgeBase">
            <Sidebar />
            <MainView>
                <KnowledgeBaseView />
            </MainView>
        </div>
    )
}

export default KnowledgeBase
